import React from 'react';
import Icon from '../Icon/Icon';
import Button from '../../common/Button/Button';
import Modal from '../Modal/Modal';
import Input from '../Input/Input';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { PAYMENT_GATEWAYS, SOURCE } from 'hb-redux-store/util/constantServices';
import RazorpayService from 'hb-redux-store/util/RazorpayService';

const Upis = props => {
  const {
    title,
    details,
    selectedMode,
    source = '',
    validateUPI,
    ctaText = 'Place Order',
  } = props;
  const { onPaymentModeChange, onPlaceOrder, pgId } = props;
  const initialUpi = { vpa: '', token: '', invalidUpi: false };
  const [showUpiModal, setUpiModal] = React.useState(false);
  const [upiDetails, setUpiDetails] = React.useState(initialUpi);
  const [saveUpi, setSaveUpi] = React.useState(true);
  const onCancel = () => setUpiModal(false);
  const successCb = () => {
    setUpiDetails({ ...upiDetails, invalidUpi: false });
    const payDetails = {
      method: 'upi',
      mode: 'pol',
      payVia: 'upi',
      vpa: upiDetails.vpa,
      save: saveUpi ? 1 : 0,
    };
    if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
      payDetails.pg = 'UPI';
      payDetails.bankcode = 'UPI';
    }
    onPlaceOrder(payDetails);
  };
  const failureCb = () => {
    setUpiDetails({ ...upiDetails, invalidUpi: true });
  };
  const onSavedUpiSelection = upi => {
    if (source === SOURCE.ACCOUNTS) return;
    setUpiDetails({
      ...initialUpi,
      token: upi.tokenId,
      vpa: `${upi.username}@${upi.handle}`,
    });
    onPaymentModeChange(upi.tokenId);
  };
  const onSaveUPI = () => {};
  const _validateUPI = () => {
    const upiData = { vpa: upiDetails.vpa, successCb, failureCb, pgId };
    validateUPI(upiData);
  };
  const onPay = () => {
    //validate data, show errors or call onPlaceOrder
    if (upiDetails.vpa && !upiDetails.token) {
      _validateUPI();
    } else if (upiDetails.token) {
      const payDetails = {
        method: 'upi',
        mode: 'pol',
        payVia: 'savedUpi',
        // token: upiDetails.token,
        vpa: upiDetails.vpa,
        save: 0,
      };
      if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
        payDetails.pg = 'UPI';
        payDetails.bankcode = 'UPI';
      }
      onPlaceOrder(payDetails);
    } else {
      setAppNotification('No UPI added.');
    }
  };
  const deleteUPI = tokenId => {};
  const getVPANetwork = handle => {
    let vpaIcon = 'icon-payment-vpa-upi';
    const VPAApps = [
      {
        app: 'PhonePe',
        handles: ['@ybl'],
        icon: 'icon-payment-wallet-phonepe',
      },
      {
        app: 'GPay',
        handles: ['@okaxis', '@okhdfcbank', '@okicici', '@oksbi'],
        icon: 'icon-payment-vpa-gpay',
      },
      { app: 'Amazon Pay', handles: ['@apl'], icon: 'icon-payment-vpa-apay' },
      { app: 'Cred', handles: ['@axisb'], icon: '' },
    ];
    VPAApps.map(app => {
      if (app.handles.indexOf(handle.toLowerCase()) > -1) {
        vpaIcon = app.icon || vpaIcon;
      }
    });
    return vpaIcon;
  };
  return (
    <React.Fragment>
      <div className="payment-mode-panel">
        <div className="payment-mode-panel--title">{title}</div>
        {details &&
          details.length > 0 &&
          details.map(upi => {
            return (
              <React.Fragment key={upi.tokenId}>
                <div
                  className={`payment-mode-panel--item ${
                    selectedMode === upi.tokenId ? 'active' : ''
                  }`}
                  onClick={() => onSavedUpiSelection(upi)}
                >
                  <div className="payment-mode-panel--item--illustration">
                    <Icon
                      class={getVPANetwork(`@${upi.handle}`)}
                      width={45}
                      height={26}
                    />
                  </div>
                  <div className="payment-mode-panel--item--name">
                    {upi.username}@{upi.handle}
                  </div>
                  {source !== SOURCE.ACCOUNTS && (
                    <div className="payment-mode-panel--item--radio">
                      {selectedMode === upi.tokenId ? (
                        <Icon size={17} class="icon-common-radio-selected" />
                      ) : (
                        <Icon size={17} class="icon-common-radio-unselected" />
                      )}
                    </div>
                  )}
                  {/*{source === SOURCE.ACCOUNTS && (*/}
                  {/*  <Button*/}
                  {/*    onClick={() => deleteUPI(upi.tokenId)}*/}
                  {/*    className="button action-link address-card--delete-action"*/}
                  {/*  >*/}
                  {/*    Delete*/}
                  {/*  </Button>*/}
                  {/*)}*/}
                </div>
                {selectedMode === upi.tokenId && (
                  <div className="saved-upi-cta">
                    <Button
                      className="button button-primary medium"
                      onClick={onPay}
                    >
                      {ctaText}
                    </Button>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        <div className="payment-mode-panel--cta justify-content--space-between">
          <div className="flex-align-items-center">
            <Icon size={30} class="icon-payment-gpay payment-mode--icon" />
            <Icon size={30} class="icon-payment-phonepe payment-mode--icon" />
            <Icon size={30} class="icon-payment-bhim payment-mode--icon" />
            <span className="payment-mode-panel--cta--more-text">& more</span>
          </div>
          {source !== SOURCE.ACCOUNTS && (
            <Button
              onClick={() => {
                onPaymentModeChange();
                setUpiModal(true);
                setUpiDetails({ ...upiDetails, token: null, vpa: '' });
              }}
              className="button action-link more"
            >
              {source !== SOURCE.ACCOUNTS ? 'Pay using new UPI' : 'Add new Upi'}
            </Button>
          )}
        </div>
      </div>
      <div className="section-divider"></div>
      <Modal
        visible={showUpiModal}
        onCancel={onCancel}
        footer={null}
        centered={true}
        destroyOnClose={true}
        maskClosable={false}
        title={source !== SOURCE.ACCOUNTS ? 'Pay using new UPI' : 'Add new Upi'}
        wrapClassName="add-new-upi"
        onModalOpen={RazorpayService.initRazorpay}
      >
        <Input
          placeholder="Enter Your UPI ID"
          className="add-new-upi--upi-input"
          onChange={({ vpa }) => setUpiDetails({ ...upiDetails, vpa })}
          name="vpa"
          type="text"
          value={upiDetails.vpa}
          hasError={upiDetails.invalidUpi}
          errorMsg="Invalid UPI"
        />
        <div
          className="add-new-upi--save-upi"
          onClick={() => setSaveUpi(!saveUpi)}
        >
          <span>Securely save save your VPA</span>
          {saveUpi ? (
            <Icon class="icon-common-checkbox-selected" size={20} />
          ) : (
            <Icon class="icon-common-checkbox-unselected" size={20} />
          )}
        </div>
        {source !== SOURCE.ACCOUNTS && (
          <Button
            className="button button-primary full-width large"
            onClick={onPay}
          >
            Verify & pay
          </Button>
        )}
        {source === SOURCE.ACCOUNTS && (
          <Button
            className="button button-primary full-width large"
            onClick={onSaveUPI}
          >
            Save Upi
          </Button>
        )}
      </Modal>
    </React.Fragment>
  );
};

export default Upis;
